/* unplugin-vue-components disabled */import script from "./Record.vue?vue&type=script&setup=true&lang=js"
export * from "./Record.vue?vue&type=script&setup=true&lang=js"

import "./Record.vue?vue&type=style&index=0&id=3e86c9b6&lang=less"

const __exports__ = script;

export default __exports__